module.exports = __webpack_public_path__ + "static/media/ankle_occluder.cc1a1bb2.obj";